import { motion } from 'framer-motion';

export function GhostZero({ isActive, text, direction }) {
    const fromX = direction === 'right' ? 120 : -120;

    return (
        <motion.div
            key={isActive ? 'show' : 'hide'}
            initial={{ x: fromX, opacity: 0 }}
            animate={isActive ? { x: 0, opacity: 0.06 } : { x: fromX, opacity: 0 }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            className="
        absolute
        inset-0
        flex items-center justify-center
        text-white
        text-[20rem] md:text-[25rem]
        font-extrabold
        leading-none
        pointer-events-none
        select-none
        z-10
      "
        >
            {text}
        </motion.div>
    );
}
